'use client';

import { RefObject } from 'react';
import Box from '../../../atoms/Box/Box';
import ReCaptchaWidget, { ReCaptchaRef } from './ReCaptchaWidget';
import type { ReCaptchaField } from '../types';

export type ReCaptchaControlProps = {
  field: ReCaptchaField;
  theme: 'dark' | 'light';
  fieldKey: number;
  reCapchaRef: RefObject<ReCaptchaRef | null>;
  onCaptchaChange: (token: string) => Promise<void>;
};

/**
 * Form control for ReCAPTCHA verification
 * @component
 * @param {ReCaptchaControlProps} props - Component props
 * @returns {JSX.Element} ReCaptcha control component
 */
const ReCaptchaControl = ({
  field,
  theme,
  fieldKey,
  reCapchaRef,
  onCaptchaChange,
}: ReCaptchaControlProps) => {
  return (
    <Box pb={field?.hideRecaptcha ? 0 : 24} key={`form_field_recaptcha_${fieldKey}`}>
      <ReCaptchaWidget
        ref={reCapchaRef}
        lng={field.lng}
        onCaptchaChange={onCaptchaChange}
        theme={theme}
        hideRecaptcha={field?.hideRecaptcha}
      />
    </Box>
  );
};

export default ReCaptchaControl;
